
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.946 3.698l-8.68 8.68a.195.195 0 01-.277 0L.06 7.449a.195.195 0 010-.276l1.198-1.198a.196.196 0 01.276 0l3.593 3.593 7.345-7.345a.196.196 0 01.276 0l1.198 1.198c.076.076.076.2 0 .277z","fill":"currentColor"}})])
          )
        }
      }
    